import { render } from "./AddNews.vue?vue&type=template&id=ab755548&scoped=true"
import script from "./AddNews.vue?vue&type=script&lang=js"
export * from "./AddNews.vue?vue&type=script&lang=js"

import "./AddNews.vue?vue&type=style&index=0&id=ab755548&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab755548"]])

export default __exports__